const isMobileEntryPath = (path: string): boolean => {
  return path === '/mobile' || path.startsWith('/mobile/') || path === '/my-new-app';
};

const bootstrapCore = async () => {
  await import('@core/config/bootstrappers/bootstrapStyles');
  const [{ createApp }, { createPinia }, appModule, i18nModule, primevueModule, leafletModule, caslModule, routerModule, fontModule] =
    await Promise.all([
      import('vue'),
      import('pinia'),
      import('./App.vue'),
      import('@core/plugins/translation/i18n'),
      import('@core/config/bootstrappers/bootstrapPrimevue'),
      import('@core/config/bootstrappers/bootstrapLeaflet'),
      import('@core/config/bootstrappers/bootstrapCasl'),
      import('@core/router'),
      import('@core/utils/core/loadFont'),
    ]);

  const App = appModule.default;
  const router = routerModule.default;
  const app = createApp(App);

  app.use(router);
  app.use(createPinia());

  await i18nModule.setupI18n(app);
  primevueModule.registerPrimevue(app);
  leafletModule.registerLeaflet(app);
  caslModule.registerCasl(app);
  fontModule.loadFontLink('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/7.0.0/css/all.min.css', 'nexus-font-awesome');

  app.mount('#app');

  return app;
};

// Delegate to app-specific entry when flag is set; fallback to core bootstrap
let appPromise: Promise<unknown>;
const target = import.meta.env?.VITE_APP_TARGET as 'desktop' | 'mobile' | undefined;
const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
const shouldUseMobileRuntime = target === 'mobile' || (!target && isMobileEntryPath(currentPath));

if (target === 'desktop') {
  appPromise = import('@/apps/desktop/default/main').then(() => undefined);
} else if (shouldUseMobileRuntime) {
  appPromise = import('@/apps/mobile/default/main').then(() => undefined);
} else {
  appPromise = bootstrapCore();
}

export { appPromise };
